export const API_BASE_URL = "https://app.manuscriptinsight.ai/services"
export const WORDPRESS_URL = "https://manuscriptinsight.ai/"
export const GOOGLE_ANALYTICS_ID = "G-LEWLCPY375"
